<template>
  <div class="user-agreement-page">
    <div class="page-container">
      <!-- 头部导航 -->
      <div class="page-header">
        <div class="logo-wrapper" @click="$router.push('/')">
          <span class="logo-text">中国品牌网</span>
        </div>
      </div>

      <!-- 页面内容 -->
      <div class="page-content">
        <div class="content-wrapper">
          <!-- 标题 -->
          <h1 class="agreement-title">用户协议</h1>
          
          <!-- 协议信息 -->
          <div class="agreement-meta">
            <span class="meta-item">协议生效日期：2026 年 9 月 15 日</span>
            <span class="meta-item">最后更新日期：2026 年 9 月 15 日</span>
          </div>

          <!-- 特别提示 -->
          <div class="special-highlight">
            <strong>【特别提示】</strong> 
            在使用中国品牌网（以下简称"本平台"或"中国品牌网"）所提供的各项服务之前，请您务必仔细阅读并透彻理解本《用户协议》（以下简称"本协议"）。当您按照页面页面提示完成全部注册/勾选同意/开始使用流程并完成全部注册流程后，即表示您已充分阅读、理解并接受本协议的全部内容，并同意按照本协议之约定享有权利、履行义务。如您不同意本协议的任何条款，请您立即停止注册、停止使用本平台所提供的任何服务。
          </div>

          <!-- 平台运营信息 -->
          <div class="platform-info">
            本平台由《中国品牌》杂志社有限责任公司（以下简称"我们"）运营，主办单位为中国品牌建设促进会，主管单位为国家市场监督管理总局。本协议是您与我们之间就使用本平台服务所订立的具有法律约束力的文件。
          </div>

          <!-- 协议正文 -->
          <div class="agreement-content">
            <!-- 一、协议主体与适用范围 -->
            <section class="agreement-section">
              <h2>一、协议主体与适用范围</h2>
              <div class="section-content">
                <p><strong>1.1 协议主体：</strong>本协议由您（以下简称"用户"或"您"）与《中国品牌》杂志社有限责任公司共同订立。</p>
                <p><strong>1.2 适用范围：</strong>本协议适用于您访问、浏览、注册、登录、使用本平台所提供的全部服务（包括但不限于品牌资讯浏览、品牌影响力指数查询、《中国品牌》杂志相关内容浏览、品牌活动报名、战略合作伙伴项目参与、品牌扶摇计划公益项目参与、广告及营销服务等），以及您通过本平台与我们发生的全部交互行为。</p>
                <p><strong>1.3 关联协议：</strong>本平台涉及的具体服务可能另有单独的协议、规则、说明、公告、页面指引等（以下统称"服务规则"），该等规则一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。</p>
                <p><strong>1.4 协议变更：</strong>鉴于互联网行业及本平台业务的高速发展，我们保留随时修改本协议的权利。修改后的协议一旦在本平台公布，即代替原协议生效。如您不同意修改后的协议，请您立即停止使用本平台服务；如您继续使用本平台服务，则视为您接受修改后的协议。</p>
              </div>
            </section>

            <!-- 二、相关定义 -->
            <section class="agreement-section">
              <h2>二、相关定义</h2>
              <div class="section-content">
                <p><strong>2.1 "本平台"/"中国品牌网"</strong>：指由《中国品牌》杂志社有限责任公司运营的官方网站，以及我们不时提供的关联移动端、微信公众号等终端形态。</p>
                <p><strong>2.2 "用户"</strong>：指访问、浏览或使用本平台服务的任何自然人、法人或其他组织，包括但不限于注册用户、游客、合作机构、品牌方、媒体同行等。</p>
                <p><strong>2.3 "注册用户"</strong>：指按照本平台注册流程完成账号注册的自然人、法人或其他组织。</p>
                <p><strong>2.4 "账号"</strong>：指用户在本平台注册的、用于识别用户身份的唯一标识。</p>
                <p><strong>2.5 "服务"</strong>：指本平台基于互联网向用户提供的品牌资讯发布、品牌影响力指数查询、品牌活动举办、广告发布、营销策划、技术推广等各类线上服务。</p>
                <p><strong>2.6 "内容"</strong>：指用户在本平台上发布、传输或接收的任何文字、图片、音视频、链接、数据、观点、评论、问答等信息。</p>
              </div>
            </section>

            <!-- 三、服务内容 -->
            <section class="agreement-section">
              <h2>三、服务内容</h2>
              <div class="section-content">
                <p>本平台主要提供以下服务（具体以本平台实际展示为准）：</p>
                <p><strong>3.1 品牌资讯发布与浏览服务：</strong>包括但不限于资讯、快消、农业、视频、专题、人物、案例、观察、科技、汽车、食品、文产、话题、品鉴、原创等品牌相关领域资讯的发布、转载与浏览。</p>
                <p><strong>3.2 品牌影响力指数服务：</strong>包括"品牌影响力指数"等品牌价值评价指数的查询、研究与发布。</p>
                <p><strong>3.3 融媒集群服务：</strong>包括"中国品牌融媒集群"及其下属矩阵账号（微博、微信公众号、微信视频号、抖音号、快手号，以及人民日报客户端、今日头条、网易、百度、腾讯等平台入驻账号）的资讯分发服务。</p>
                <p><strong>3.4 品牌活动服务：</strong>包括"中国品牌发展现状调研行"、"中国品牌会议活动"等品牌相关会议、论坛、调研、沙龙等活动的组织、报名、参与服务。</p>
                <p><strong>3.5 品牌研究服务：</strong>包括依托《中国品牌》杂志社·中国品牌研究院开展的课题研究、调研研讨、立项课题、指数发布、行业报告等服务。</p>
                <p><strong>3.6 战略合作与公益服务：</strong>包括"中国品牌战略合作伙伴"、"品牌扶摇计划公益项目"等合作与公益类服务。</p>
                <p><strong>3.7 广告与营销服务：</strong>包括基于《中国品牌》杂志、中国品牌网及融媒集群所提供的广告设计、制作及发布，社会经济咨询，营销策划，企业形象策划，承办展览展示，会议服务，技术推广等服务。</p>
                <p><strong>3.8 其他服务：</strong>我们不时提供的、并在相关页面展示的其他服务。</p>
              </div>
            </section>

            <!-- 四、用户注册与账号管理 -->
            <section class="agreement-section">
              <h2>四、用户注册与账号管理</h2>
              <div class="section-content">
                <p><strong>4.1 注册资格</strong></p>
                <p>您确认，在您开始注册流程并使用本平台服务时，您应当具备中华人民共和国法律规定的、与您行为相适应的民事行为能力。若您不具备前述民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>
                <p><strong>4.2 注册流程</strong></p>
                <p>您应按照本平台页面的引导真实、准确、完整地提供注册信息，并及时更新相关信息。您承诺不得以他人身份信息注册账号，不得冒用、盗用、伪造、变造任何机构或他人的身份信息、营业执照、资质证明等材料。</p>
                <p><strong>4.3 账号安全</strong></p>
                <p>您应妥善保管您的账号、密码及验证码，并对您账号项下的全部行为承担法律责任。请勿将您的账号、密码转让、出借、出租或以其他方式提供给他人使用。因您主动泄露、遭受他人攻击、诈骗或因您未妥善保管账号与密码所导致的一切后果，均由您自行承担。</p>
                <p><strong>4.4 账号注销</strong></p>
                <p>如您需要注销账号，可以通过本平台公布的联系方式与我们联系，在核实您的身份后，我们将按照法律法规及本平台规则为您办理账号注销。注销后，我们将依据本《隐私条款》的约定对您的个人 (企业) 信息进行删除或匿名化处理。</p>
              </div>
            </section>

            <!-- 五、用户行为规范 -->
            <section class="agreement-section">
              <h2>五、用户行为规范</h2>
              <div class="section-content">
                <p>您承诺在使用本平台服务时，应严格遵守中华人民共和国法律法规、社会公德、商业道德及本协议约定，并对您在本平台上的一切行为承担全部责任。您不得从事下列行为，也不得为下列行为提供便利：</p>
                <ol>
                  <li>违反宪法确定的基本原则，危害国家安全、荣誉和利益，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
                  <li>损害国家荣誉和利益的，歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</li>
                  <li>宣扬恐怖主义、极端主义、种族主义、仇恨言论、邪教，或者煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                  <li>散布谣言、虚假信息，扰乱经济秩序和社会秩序，破坏社会稳定的；</li>
                  <li>侮辱、诽谤他人，侵害他人名誉权、隐私权、肖像权、知识产权等合法权益的；</li>
                  <li>发布、传送、传播含有淫秽、色情、赌博、暴力、凶杀、恐怖、惊悚或者教唆犯罪、危害未成年人身心健康等不良内容的；</li>
                  <li>发布、传送、传播任何侵犯他人著作权、商标权、专利权、商业秘密等知识产权的内容；</li>
                  <li>虚构事实、隐瞒真相，发布虚假品牌资讯、企业信息、营销案例或测评结果的；</li>
                  <li>发布任何广告信息、垃圾信息、骚扰信息、过度营销信息，或从事任何不正当竞争行为的；</li>
                  <li>通过技术手段批量注册、伪造账号身份、刷量、刷评、刷榜、恶意占用资源、干扰平台正常运行的；</li>
                  <li>利用技术手段或其他非法手段攻击、破解、篡改、破坏本平台系统、网络或数据的；</li>
                  <li>从事任何违反法律法规、本协议或本平台其他规则的、可能对本平台、其他用户或第三方造成不利影响的行为。</li>
                </ol>
              </div>
            </section>

            <!-- 六、用户内容与知识产权 -->
            <section class="agreement-section">
              <h2>六、用户内容与知识产权</h2>
              <div class="section-content">
                <p><strong>6.1 用户内容的所有权</strong></p>
                <p>您在本平台发布、上传、提交或以其他方式提供的文字、图片、音视频、链接、评论等内容，其所有权及知识产权仍归您或合法权利人所有。但您应保证，您拥有或已经获得合法授权，有权将上述内容在本平台进行发布、传播、使用及许可我们使用。</p>
                <p><strong>6.2 平台内容的知识产权</strong></p>
                <p>本平台所提供的全部内容（包括但不限于文字、图片、音视频、设计稿、界面设计、版面框架、数据、源代码、品牌影响力指数、品牌研究报告、期刊内容、商标、Logo 等）的知识产权，归我们或合法权利人所有，受中华人民共和国法律法规及国际公约的保护。未经我们或相关权利人事先书面许可，您不得以任何形式复制、转载、修改、传播、发行、镜像、上载、下载、翻译、汇编或用于任何商业目的。</p>
                <p><strong>6.3 内容许可</strong></p>
                <p>您理解并同意，对于您在本平台发布的合法内容，您授予我们一项全球范围内、非独家、可转让、可再许可、免许可费、永久的许可，以用于本平台及《中国品牌》杂志社融媒集群的展示、传播、推广、再编辑、出版、归档、备份等合理使用用途。</p>
                <p><strong>6.4 反馈意见</strong></p>
                <p>对于您通过本平台向我们提供的反馈、建议或创意，您同意我们有权不受限制地自由使用该等内容，且无需向您支付任何费用或承担任何义务。</p>
              </div>
            </section>

            <!-- 七、个人 (企业) 信息保护 -->
            <section class="agreement-section">
              <h2>七、个人 (企业) 信息保护</h2>
              <div class="section-content">
                <p><strong>7.1 保护您的个人 (企业) 信息是我们的一项基本原则。</strong>关于您的个人 (企业) 信息的收集、使用、存储、保护及共享规则，请详见本平台公布的《隐私条款》，该《隐私条款》构成本协议不可分割的组成部分。</p>
                <p><strong>7.2</strong>您理解并同意，您在本平台上提供的个人 (企业) 信息将根据《隐私条款》进行收集、使用和保护，您应在使用本平台服务前仔细阅读并充分理解《隐私条款》全部内容。</p>
                <p><strong>7.3</strong>您应保证您向我们提供的任何个人 (企业) 信息（包括但不限于他人的姓名、联系方式、单位信息等）已经获得了相关当事人的合法授权或同意。如因此引发任何纠纷或法律责任，应由您自行承担。</p>
              </div>
            </section>

            <!-- 八、广告与第三方服务 -->
            <section class="agreement-section">
              <h2>八、广告与第三方服务</h2>
              <div class="section-content">
                <p><strong>8.1</strong>本平台可能向您展示第三方提供的广告、商品、服务或其他信息。该等广告内容由广告主或广告经营者自行负责，我们仅提供展示平台，不对广告内容的真实性、合法性、准确性作出任何明示或暗示的保证。</p>
                <p><strong>8.2</strong>本平台可能包含指向第三方网站、应用程序或服务的链接。您通过该等链接进入第三方网站或服务时，应自行评估其风险，并自行与该等第三方建立法律关系。我们不对第三方网站或服务的任何内容、政策、行为承担任何责任。</p>
                <p><strong>8.3</strong>您与我们基于《中国品牌》杂志广告发布、营销策划、展览展示、会议服务、技术推广等业务进行合作时，应另行签署具体业务合作协议，相关权利义务以该等具体协议为准。</p>
              </div>
            </section>

            <!-- 九、免责声明 -->
            <section class="agreement-section">
              <h2>九、免责声明</h2>
              <div class="section-content">
                <p>在适用法律允许的最大范围内，我们特别提示您注意：</p>
                <p><strong>9.1</strong>本平台所提供的资讯、报告、指数、评论等内容，仅供您参考之用，不构成任何投资、营销、法律、税务、会计或其他专业建议或意见，不应被视为任何行动的依据。</p>
                <p><strong>9.2</strong>您理解，互联网服务具有技术依赖性强、受网络环境、终端设备、第三方服务等因素影响较大的特点。我们不对本平台服务的及时性、安全性、准确性、可用性、连续性、可靠性、无错误、无病毒、无中断或无瑕疵作出任何明示或暗示的保证。</p>
                <p><strong>9.3</strong>因下列情形导致您无法使用本平台服务或造成损失的，我们不承担责任：</p>
                <ol>
                  <li>因不可抗力（包括但不限于自然灾害、战争、政府行为、电信基础设施故障等）导致的；</li>
                  <li>因您自身的设备、网络故障或操作不当导致的；</li>
                  <li>因黑客攻击、计算机病毒、网络拥堵、系统不稳定等第三方原因导致的；</li>
                  <li>因您违反本协议约定导致的；</li>
                  <li>法律法规及政策调整导致的。</li>
                </ol>
                <p><strong>9.4</strong>我们有权基于运营需要、技术升级、合规要求等原因，随时对本平台服务的全部或部分内容进行变更、中止或终止，且无需事先征得您的同意。</p>
                <p><strong>9.5</strong>您应自行承担使用本平台服务所产生的全部风险，包括但不限于因依据本平台内容所做出的任何决定所造成的后果。</p>
              </div>
            </section>

            <!-- 十、违约责任与处理 -->
            <section class="agreement-section">
              <h2>十、违约责任与处理</h2>
              <div class="section-content">
                <p><strong>10.1</strong>如您违反本协议或本平台其他规则的，我们有权采取下列措施中的一项或多项：</p>
                <ol>
                  <li>警告、警示、责令改正；</li>
                  <li>限制您使用本平台全部或部分功能；</li>
                  <li>暂停、中止或终止向您提供本平台全部或部分服务；</li>
                  <li>封禁、注销您的账号；</li>
                  <li>删除您发布的相关内容；</li>
                  <li>依法追究您的法律责任；</li>
                  <li>我们认为适当的其他措施。</li>
                </ol>
                <p><strong>10.2</strong>如您的行为给我们、本平台其他用户或第三方造成损失的，您应当依法承担赔偿责任；构成犯罪的，我们将依法向司法机关举报。</p>
              </div>
            </section>

            <!-- 十一、协议变更、中止与终止 -->
            <section class="agreement-section">
              <h2>十一、协议变更、中止与终止</h2>
              <div class="section-content">
                <p><strong>11.1 协议变更：</strong>您理解并同意，我们有权根据法律法规变更、业务调整、平台升级等原因对本协议进行修改。修改后的协议一经在本平台发布即生效。如您不同意修改后的协议，您有权停止使用本平台服务；如您继续使用，则视为您接受修改。</p>
                <p><strong>11.2 协议中止：</strong>在下列情况下，我们有权中止向您提供本平台服务：</p>
                <ol>
                  <li>您违反本协议或本平台规则的；</li>
                  <li>根据法律法规或主管部门要求必须中止的；</li>
                  <li>因系统维护、升级、故障等客观原因需要暂时中止的；</li>
                  <li>其他我们认为需要中止的合法情形。</li>
                </ol>
                <p><strong>11.3 协议终止：</strong>下列情形发生时，本协议终止：</p>
                <ol>
                  <li>您主动注销账号或书面通知我们终止使用本平台服务的；</li>
                  <li>我们决定终止本平台运营的；</li>
                  <li>法律法规或主管部门要求终止的；</li>
                  <li>其他依本协议应当终止的情形。</li>
                </ol>
                <p><strong>11.4 协议终止后的处理：</strong>本协议终止后，除法律另有规定或双方另有约定外，您在本平台项下的全部权利义务终止，但我们仍有权依据法律法规及本《隐私条款》继续保留或依法处理您的相关信息。</p>
              </div>
            </section>

            <!-- 十二、法律适用与争议解决 -->
            <section class="agreement-section">
              <h2>十二、法律适用与争议解决</h2>
              <div class="section-content">
                <p><strong>12.1 法律适用：</strong>本协议的订立、执行、解释及争议解决均适用中华人民共和国法律法规（为本协议之目的，不包括香港特别行政区、澳门特别行政区和台湾地区的法律）。</p>
                <p><strong>12.2 争议解决：</strong>如本协议各方就本协议内容或执行发生任何争议，应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交《中国品牌》杂志社有限责任公司所在地有管辖权的人民法院通过诉讼方式解决。</p>
                <p><strong>12.3 可分割性：</strong>本协议中任何条款被认定为无效、非法或不可执行的，不影响其他条款的效力。</p>
                <p><strong>12.4</strong>标题仅为方便阅读，不影响相关条款内容的解释。</p>
              </div>
            </section>

            <!-- 十三、联系我们 -->
            <section class="agreement-section">
              <h2>十三、联系我们</h2>
              <div class="section-content">
                <p>如您对本协议或本平台服务有任何疑问、意见、建议或投诉，请通过以下方式与我们联系：</p>
                <p><strong>运营主体：</strong>《中国品牌》杂志社有限责任公司</p>
                <p><strong>统一社会信用代码：</strong>91110106795986730N</p>
                <p><strong>办公地址：</strong>北京市朝阳区北三环东路 18 号院 6 号楼</p>
                <p><strong>联系电话：</strong>010-65283638</p>
                <p><strong>电子邮箱：</strong>bd@cbrand.com.cn</p>
                <p><strong>主管单位：</strong>国家市场监督管理总局</p>
                <p><strong>主办单位：</strong>中国品牌建设促进会</p>
                <p><strong>业务归口：</strong>国家市场监督管理总局新闻宣传司</p>
                <p><strong>期刊信息：</strong>国际标准刊号 ISSN 1673-7741，国内统一刊号 CN 11-5562/T</p>
                <p><strong>ICP 备案：</strong>京 ICP 备 16035947 号</p>
                <p><strong>官方网站：</strong>https://www.cbrand.com.cn</p>
                <p>我们将在收到您的反馈后 15 个工作日内予以回复处理。</p>
              </div>
            </section>

            <!-- 十四、其他 -->
            <section class="agreement-section">
              <h2>十四、其他</h2>
              <div class="section-content">
                <p><strong>14.1</strong>本协议自您点击同意或开始使用本平台服务之日起生效。</p>
                <p><strong>14.2</strong>本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议相关条款解释的依据。</p>
                <p><strong>14.3</strong>本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对各方具有约束力。</p>
                <p><strong>14.4</strong>您与我们之间的法律关系不因本协议的签署而建立任何劳动、雇佣、代理、合伙、特许经营等法律关系。</p>
                <p><strong>14.5</strong>本协议未尽事宜，按照中华人民共和国相关法律法规及行业惯例执行。</p>
              </div>
            </section>
          </div>

          <!-- 底部声明 -->
          <div class="agreement-footer">
            <p>请您再次确认：您已经仔细阅读、充分理解并接受本《用户协议》的全部条款，并同意按照本协议之约定行使权利、履行义务。如您不同意本协议的任何条款，请立即停止使用本平台服务。</p>
            <p class="copyright">© 版权所有《中国品牌》杂志社有限责任公司 保留一切权利</p>
          </div>

          <!-- 返回按钮 -->
          <!-- <div class="back-button">
            <button class="btn btn-secondary" @click="$router.back()">返回列表</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  mounted() {
    // 设置页面标题
    document.title = '用户协议 - 中国品牌网'
  }
}
</script>

<style scoped>
.user-agreement-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-container {
  width: 100%;
}

/* 页面头部 */
.page-header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 0;
}

.logo-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  cursor: pointer;
  text-align: center;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #B91816;
}

/* 页面内容区域 */
.page-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.content-wrapper {
  padding: 40px;
}

/* 标题样式 */
.agreement-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #B91816;
  padding-bottom: 20px;
}

/* 协议元信息 */
.agreement-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  color: #666;
  font-size: 14px;
}

/* 特别提示 */
.special-highlight {
  background-color: #FFF3CD;
  border-left: 4px solid #FFC107;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 4px;
  font-size: 14px;
}

.special-highlight strong {
  color: #856404;
}

/* 平台信息 */
.platform-info {
  background-color: #E7F3FF;
  border-left: 4px solid #2196F3;
  padding: 16px 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  color: #0C5460;
  font-size: 14px;
}

/* 协议章节 */
.agreement-section {
  margin-bottom: 40px;
  page-break-inside: avoid;
}

.agreement-section h2 {
  font-size: 22px;
  color: #B91816;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.section-content {
  color: #333;
  line-height: 1.8;
  font-size: 15px;
}

.section-content p {
  margin-bottom: 12px;
  text-align: justify;
}

.section-content ol {
  margin-left: 24px;
  margin-bottom: 12px;
}

.section-content li {
  margin-bottom: 8px;
}

/* 页脚声明 */
.agreement-footer {
  background-color: #f9f9f9;
  border-left: 4px solid #666;
  padding: 20px;
  margin-top: 40px;
  margin-bottom: 40px;
  border-radius: 4px;
  font-size: 14px;
}

.agreement-footer p {
  margin-bottom: 12px;
}

.agreement-footer .copyright {
  color: #999;
  font-size: 14px;
  margin-top: 20px;
}

/* 返回按钮 */
.back-button {
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.btn {
  padding: 12px 32px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;
}

.btn-secondary {
  background-color: #fff;
  border-color: #ddd;
  color: #666;
}

.btn-secondary:hover {
  background-color: #f5f5f5;
  border-color: #ccc;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-content {
    padding: 20px 10px;
    margin-top: 10px;
  }

  .content-wrapper {
    padding: 20px;
  }

  .agreement-title {
    font-size: 24px;
  }

  .agreement-meta {
    flex-direction: column;
    gap: 10px;
  }

  .section-content {
    font-size: 14px;
  }
}
</style>
